import { useEffect, useRef } from "react";

export default function MarketOverview() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    // Clean previous renders (hot reload / navigation)
    ref.current.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      colorTheme: "dark",
      dateRange: "12M",
      showChart: true,
      showSymbolLogo: true,
      isTransparent: false,
      width: "100%",
      height: 560,
      autosize: true,
      locale: "en",
      tabs: [
        {
          title: "Indices",
          symbols: [
            { s: "FOREXCOM:SPXUSD", d: "S&P 500" },
            { s: "FOREXCOM:NSXUSD", d: "US 100" },
            { s: "FOREXCOM:DJI", d: "Dow Jones" },
            { s: "INDEX:NKY", d: "Nikkei 225" },
            { s: "INDEX:DAX", d: "DAX" }
          ],
          originalTitle: "Indices"
        },
        {
          title: "Futures",
          symbols: [
            { s: "CME_MINI:ES1!", d: "S&P 500 Futures" },
            { s: "NYMEX:CL1!", d: "WTI Crude" },
            { s: "COMEX:GC1!", d: "Gold" },
            { s: "CBOT:ZC1!", d: "Corn" }
          ],
          originalTitle: "Futures"
        },
        { title: "Bonds", symbols: [{ s: "TVC:US10Y", d: "U.S. 10Y" }] },
        { title: "Forex", symbols: [{ s: "FX:EURUSD", d: "EUR/USD" }] }
      ]
    });

    const widgetDiv = document.createElement("div");
    widgetDiv.className = "tradingview-widget-container__widget";
    ref.current.appendChild(widgetDiv);
    ref.current.appendChild(script);
  }, []);

  // Center it and cap to a readable width
  return (
    <div className="mx-auto" style={{ maxWidth: 1000 }}>
      <div className="tradingview-widget-container" ref={ref} />
    </div>
  );
}
